export default "__VITE_ASSET__B$tulQgN__"